import React, { useState, useEffect } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useHistory, useLocation } from "react-router-dom";
import UnitList from '../unit/UnitList';
import { COLOR_WHITE } from '../../../const';
import SurvivalNumber from './SurvivalNumber';
import { ReactIcons } from '../../../icons';
import Promotions from './Promotions';
import StockOptions from './stockOptions/StockOptions';

function OptionTabs() {
    const history = useHistory();
    const location = useLocation();
    const [activeKey, setActiveKey] = useState("unit");

    // Update URL whenever a tab is selected
    const handleSelect = (key) => {
        setActiveKey(key);
    };

    return (
        <div className="p-4">
            <h5>ຕົວເລືອກ</h5>
            <p>ຂໍ້ມູນຕົວເລຶອກໃນລະບົບ</p>
            <Tabs
                activeKey={activeKey}
                onSelect={handleSelect}
                id="uncontrolled-tab-example"
                className="mb-3"
                style={{ background: COLOR_WHITE }}
            >
                <Tab eventKey="unit" title={<div className='px-4'> <ReactIcons.FaUnity /> ຫົວໜ່ວຍ </div>}>
                    {activeKey === "unit" && <UnitList />}
                </Tab>
                <Tab eventKey="survival" title={<div className='px-4'> <ReactIcons.MdOutlineConfirmationNumber /> ເລກລອດ </div>} >
                    {activeKey === "survival" && <SurvivalNumber />}
                </Tab>
                <Tab eventKey="promotions" title={<div className='px-4'> <ReactIcons.BsBookmarksFill /> ໂປຣໂມຊັ່ນ </div>}>
                    {activeKey === "promotions" && <Promotions />}
                </Tab>
                <Tab eventKey="stockOption" title="ກະກຽມສິນຄ້າເສີມ">
                    {activeKey === "stockOption" && <StockOptions tabKey={activeKey} />}
                </Tab>
            </Tabs>
        </div>
    );
}

export default OptionTabs;
